<template>
  <cac-input-wrapper
    :title="options.label"
    :for="id">
    <div
      v-for="option in formattedCheckboxOptions"
      :key="option.value"
      class="personal-information__custom-field--checkbox">
      <input
        :id="`${option.id}_${options.id}`"
        :value="option.value"
        v-model="value"
        type="checkbox"
        class="input-checkbox"
        @change="checkedField(options, option.label, $event)">
      <label
        :for="`${option.id}_${options.id}`"
        class="input-checkbox__label">{{ option.label }}</label>
    </div>
  </cac-input-wrapper>
</template>

<script>
import CacInputWrapper from "CivicActionCenterComponents/utilities/CACInputWrapper.vue";
import CustomFieldValidationMixin from "JS/mixins/campaign/civicactioncenter/customFieldValidation";

export default {
  name: "CustomCheckbox",
  components: { CacInputWrapper },
  mixins: [CustomFieldValidationMixin],
  props: {
    options: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      value: []
    };
  },
  computed: {
    formattedCheckboxOptions() {
      return this.options.options.map(option => ({
        value: option,
        label: option,
        id: option
      }));
    }
  }
};
</script>
